import cx from 'classnames';
import { isEmpty } from 'lodash';
import React, { FC, useMemo } from 'react';

import { ListShowsEvents } from '@/components/molecules/renders';
import { Section } from '@/helpers/Section';

import block from './block.json';
import { getStyles } from './styles.css';

export type SectionCardsShowProps = {
	events: Array<CardShowType>;
	variants?: Array<'with-background'>;
} & Pick<SectionOneColumnProps, 'anchor' | 'className' | 'title'>;

/**
 * COMPONENT
 */
export const SectionCardsShow: FC<SectionCardsShowProps> & BlockConfigs = ({
	anchor,
	className,
	title,
	children,
	events = [],
	variants = [],
}) => {
	const rootClass = cx(
		'supt-section supt-section--section-cards-show -with-background',
		getStyles(),
		className,
		variants.map((variant) => `-${variant}`)
	);

	const { hasButtons, buttons } = useMemo(() => {
		const newBtnsChildren: any = { ...(children as any) };

		if (newBtnsChildren?.props?.blocks?.[0]) {
			newBtnsChildren.props.blocks[0].innerBlocks = (
				children as any
			).props.blocks?.[0]?.innerBlocks.filter(
				(block) => !!(block.attributes?.href ?? null)
			);
		}

		return {
			hasButtons:
				!!newBtnsChildren?.props?.blocks?.[0]?.innerBlocks?.length,
			buttons: newBtnsChildren,
		};
	}, [children]);

	return (
		!isEmpty(events) && (
			<section id={anchor} className={rootClass}>
				<div className="supt-section__inner">
					{title && (
						<div className="supt-section__headline">
							<Section.Title text={title} titleTag="h2" />
						</div>
					)}
					{hasButtons && (
						<div className="supt-section__buttons">{buttons}</div>
					)}
					<div className="supt-section__content">
						<ListShowsEvents events={events} />
					</div>
				</div>
			</section>
		)
	);
};

SectionCardsShow.slug = block.slug;
SectionCardsShow.title = block.title;
